<template>
    <CRow>
        <CCol sm="12">
            <CCard>
                <CCardHeader>
                    <CRow>
                        <CCol class="mt-3">
                            <h5>List Vendors</h5>
                        </CCol>
                    </CRow>
                </CCardHeader>
                <br />

                <CCardBody :style="{ position: 'relative', top: '-18px' }">
                    <CRow>
                        <CCol sm="3">
                            <CInput
                                placeholder="Search vendor name"
                                :value.sync="searchVal"
                                :lazy="800"
                                horizontal
                            />
                        </CCol>
                        <CCol sm="5"></CCol>
                        <CCol>
                            <CSelect
                                v-if="isSysAdmin || isGroupAdmin"
                                :options="clientList"
                                placeholder="Filter on client"
                                :value.sync="clientFilter"
                                label="Client Filter:"
                                horizontal
                            />
                        </CCol>
                    </CRow>

                    <CDataTable
                        :items="filteredVendorData"
                        :fields="fields"
                        :column-filter="false"
                        :items-per-page="limit"
                        :itemsPerPageSelect="true"
                        hover
                        sorter
                        pagination
                        @pagination-change="
                            (item) => {
                                limit = item;
                                offset = 0;
                                getVendors(limit, offset, clientFilter);
                            }
                        "
                        @filtered-items-change="setCurrentItems"
                    >
                        <template #action="{ item, index }">
                            <td class="py-0">
                                <CButton
                                    color="success"
                                    square
                                    size="sm"
                                    class="m-1"
                                    @click="editItem(item, index)"
                                    v-c-tooltip="{
                                        content: 'Edit',
                                        placement: 'bottom',
                                    }"
                                >
                                    <CIcon name="cil-pencil" />
                                </CButton>
                            </td>
                        </template>
                        <template #client_name="{ item }">
                            <td>{{ item.client.name || "" }}</td>
                        </template>
                    </CDataTable>
                </CCardBody>
                <CRow style="padding-bottom: 20px" v-if="pageCount > 0">
                    <CCol></CCol>
                    <CCol>
                        <CButton
                            color="primary"
                            class="m-2"
                            download="coreui-table-data.csv"
                            target="_blank"
                            :disabled="offset === 0"
                            @click="fetchFirstPage"
                            >First
                        </CButton>
                        <CButton
                            color="primary"
                            class="m-2"
                            download="coreui-table-data.csv"
                            target="_blank"
                            :disabled="offset < 1"
                            @click="getPreviousPage"
                            >Previous
                        </CButton>
                        page {{ offset / limit + 1 }} of {{ pageCount }}
                        <CButton
                            color="primary"
                            class="m-2"
                            download="coreui-table-data.csv"
                            target="_blank"
                            :disabled="pageCount === offset / limit + 1"
                            @click="getNextPage"
                            >Next
                        </CButton>
                        <CButton
                            color="primary"
                            class="m-2"
                            download="coreui-table-data.csv"
                            target="_blank"
                            :disabled="pageCount === offset / limit + 1"
                            @click="fetchLastPage"
                            >Last
                        </CButton>
                    </CCol>
                    <CCol> </CCol>
                </CRow>
            </CCard>
        </CCol>
        <!-- Response -->
        <Success
            :modal="success.enable"
            :message="success.message"
            @res-handler="success.enable = false"
            @close="success.enable = false"
        />

        <!-- Import module -->
        <Import
            title="Import vendors"
            :modal="importModal"
            type="vendor"
            :selectClient="true"
            @close="importModal = false"
        />

        <CElementCover v-if="spinner" :opacity="0.8" />
    </CRow>
</template>

<script>
import { GET_VENDORS, SEARCH_VENDORS } from "./vendorQueries";
import { storeData } from "../../store";
import XLSX from "xlsx";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { SET_VENDORS, SET_VENDOR_KEYWORD } from "./vendorQueries";
import { SET_VENDOR_CATEGORY_ALLOCATIONS } from "./vendorQueries";

const fields = [
    { key: "vendor_name" },
    { key: "po_spend" },
    { key: "non_po_spend" },
    { key: "total_categories" },
    {
        key: "action",
        label: "Action",
        _style: "min-width: 6rem",
        sorter: false,
        filter: false,
    },
];

export default {
    name: "Vendors",
    components: {
        Loading,
    },
    data() {
        return {
            fields,
            successUpload: false,
            failedVendorBool: false,
            currentItems: [],
            vendorData: [],
            filteredVendorData: [],
            vendorCategoryAllocation: [],
            importModal: false,
            failedVendors: [],
            templateData: {
                vendor_name: "",
                non_po_spend: "",
                total_categories: "",
                po_spend: "",
            },
            success: { enable: false, message: "", color: "danger" },
            confirm: { enable: false, type: "" },

            limit: 5,
            offset: 0,
            pageCount: 0,

            searchVal: "",
            searchedVendors: [],

            clientFilter: "",
            spinner: false,
        };
    },
    watch: {
        searchVal() {
            if (this.searchVal != "") {
                this.offset = 0;
                this.getVendors(this.limit, this.offset, this.clientFilter);
            } else {
                this.offset = 0;
                this.getVendors(this.limit, this.offset, this.clientFilter);
            }
        },
        clientFilter() {
            this.getVendors(this.limit, this.offset, this.clientFilter);
        },
    },
    computed: {
        isSysAdmin() {
            return storeData.currentUserDetails.role.name === "sys_admin";
        },
        isGroupAdmin() {
            return storeData.currentUserDetails.role.name === "group_admin";
        },
        clientList() {
            return storeData.clientList.filter((el) => el.label !== "All");
        },
    },
    methods: {
        downloadTemplate() {
            const blankCategoryOpportunity = [];
            blankCategoryOpportunity.push(this.templateData);
            const exportData = XLSX.utils.json_to_sheet(
                blankCategoryOpportunity
            );
            const workBook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workBook, exportData, "Data");
            XLSX.writeFile(workBook, "Vendor Template.xlsx");
        },
        getPrimeCategoryId(name) {
            for (const el of storeData.primeCategories) {
                if (el.name == name) {
                    return el.id;
                }
            }
            return 0;
        },
        getCategoryId(name) {
            for (const el of storeData.categories) {
                if (el.name == name) {
                    return el.id;
                }
            }
            return 0;
        },
        getSubCategoryId(name) {
            for (const el of storeData.subCategories) {
                if (el.name == name) {
                    return el.id;
                }
            }
            return 0;
        },
        setCurrentItems(val) {
            this.currentItems = val;
        },
        editItem(item, index) {
            storeData.vendorData = item;
            storeData.vendorAllocationData =
                storeData.vendorCategoryAllocation.filter(
                    (el) => el.vendor_id === item.id
                );
            storeData.lastClientFilter = this.clientFilter;
            this.$router.push(`/vendors/edit/${item.id}`);
        },
        getVendors(limit, offset, clientId = null) {

            // Prepare the vendor name filter
            const vendorFilter = this.searchVal
                ? `%%${this.searchVal.trim()}%%`
                : "%%";


            if (clientId === "") clientId = this.clientList[0].value;
            this.spinner = true;
            this.$apollo
                .mutate({
                    mutation: GET_VENDORS,
                    variables: {
                        limit_value: limit,
                        offset_value: offset,
                        client: clientId, // Client ID
                        vendors: vendorFilter, // Vendor name filter
                    },
                })
                .then((res) => {

                    // Process the response and update vendor data
                    const vendors = res?.data?.spendmd_db_ap_vendors || [];
                    this.vendorData = vendors;
                    this.pageCount =
                        Math.ceil(
                            res?.data?.spendmd_db_ap_vendors_aggregate
                                ?.aggregate?.count / this.limit
                        ) || 0;

                    // Set the filtered vendor data
                    this.filteredVendorData = vendors;

                    this.spinner = false;
                })
                .catch((err) => {
                    this.spinner = false;
                    console.error("Error fetching vendors:", err);
                });
        },
        fetchFirstPage() {
            this.offset = 0;
            this.getVendors(this.limit, this.offset, this.clientFilter);
        },
        getPreviousPage() {
            if (this.offset >= this.limit) {
                this.offset -= this.limit;
                this.getVendors(this.limit, this.offset, this.clientFilter);
            }
        },
        getNextPage() {
            if (this.offset + this.limit < this.pageCount * this.limit) {
                this.offset += this.limit;
                this.getVendors(this.limit, this.offset, this.clientFilter);
            }
        },
        fetchLastPage() {
            this.offset = (this.pageCount - 1) * this.limit;
            this.getVendors(this.limit, this.offset, this.clientFilter);
        },
    },

    beforeMount() {
        console.log("lastClientFilter", storeData.lastClientFilter);
        if (storeData.lastClientFilter) {
            this.clientFilter = storeData.lastClientFilter;
        } else if (!this.clientFilter && this.clientList.length > 0) {
            this.clientFilter = this.clientList[0].value;
        }

        this.getVendors(this.limit, this.offset, this.clientFilter);
    },

    beforeDestroy() {
        // Clear lastClientFilter only if not navigating to EditVendor page
        if (!this.$route.path.includes('/vendors/edit')) {
            storeData.lastClientFilter = null;
        }
    },
};
</script>
